"use client";

import { Link } from "@repo/next-utils/router";
import * as Container from "@repo/ui/container";
import {
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_LINK2_CAPS,
} from "@/theme/topshop-2/typography/typography-constants";
import { getErrorMessage } from "@/utils/error-messages";

import classes from "./error-message.module.css";

type ErrorMessageProps = {
  title: string;
  message: string;
};

export const ErrorMessage = ({
  errorCode,
  title,
  message,
}: { errorCode?: string } & ErrorMessageProps) => {
  const error = errorCode ? getErrorMessage(errorCode) : { title, message };

  return (
    <>
      <Container.Root size="medium" className={classes.container}>
        <h1 className={`${classes.title}`}>{error.title}</h1>
        <div className={classes.messageContainer}>
          <p className={`${TYPOGRAPHY_BODY3_SENTENCE} ${classes.message}`}>
            {error.message}
          </p>
          <div className={classes.linkContainer}>
            <Link href="/topshop" className={TYPOGRAPHY_LINK2_CAPS}>
              Shop Topshop
            </Link>

            <Link href="/topman" className={TYPOGRAPHY_LINK2_CAPS}>
              Shop Topman
            </Link>
          </div>
        </div>
      </Container.Root>
    </>
  );
};
